import React, { useState, useEffect } from "react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  ToastMessageError,
  ToastMessageWarning,
} from "../../../../components/common/ToastMessage";

import {
  useSearchCheckFlexTimeSubordinateCalendarBySpecificDate,
  useSearchHrChecker,
} from "../../../../utility/hooks/react-query/useFlexTimeData";

import moment from "moment";

const CalendarModal = ({
  setADayLeaveModal,
  aDayLeaveModal,
  setDateOnClick,
  dateOnClick,
  getUrlParamSearch,
  getValues,
}) => {
  const [dataModal, setDataModal] = useState([]);

  // react-query
  //#region react-query => search-data
  const onSuccessSearchData = (data) => {
    if (data.data && data.data.Status == true) {
      // console.log(data.data.ResultOnDb);
      // setDataModal(
      //   data.data.ResultOnDb.filter((item) => {
      //     return item.display != "background";
      //   })
      // );
      setDataModal(
        data.data.ResultOnDb.filter(
          (item) => item.display !== "background"
        ).filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.FLEX_TIME_REQUEST_ID === item.FLEX_TIME_REQUEST_ID
            )
        )
      );
    } else {
      const message = {
        title: "Search Events",
        message: data.data.Message,
      };

      // ToastMessageWarning(message);
    }
  };

  const onErrorSearchData = (error) => {
    const message = {
      title: "Search Events",
      message: error.Message,
    };
    ToastMessageError(message);
  };

  const { isLoading, error, data, isSuccess, isFetching } =
    useSearchCheckFlexTimeSubordinateCalendarBySpecificDate(
      onSuccessSearchData,
      onErrorSearchData,
      getUrlParamSearch(getValues(), dateOnClick, dateOnClick)
    );
  //#endregion react-query => search-data

  useEffect(() => {
    console.log(dataModal);
  }, [dataModal]);

  if (isLoading) {
    return;
  }

  return (
    <Modal
      isOpen={aDayLeaveModal}
      toggle={() => setADayLeaveModal(!aDayLeaveModal)}
      className="modal-dialog-centered"
    >
      <ModalHeader toggle={() => setADayLeaveModal(!aDayLeaveModal)}>
        Employee Flex Time On{" "}
        {moment(new Date(dateOnClick)).format("DD MMM YYYY")}
      </ModalHeader>
      <ModalBody>
        {isSuccess && dataModal.length > 0 ? (
          dataModal.map((item, index) => {
            return (
              <ul>
                <li>
                  {item.FLEX_TIME_REQUEST_EMPLOYEE_ID} {item.EMPLOYEE_NAME}{" "}
                  {item.EMPLOYEE_DEPT}
                  {" - "}
                  {item.FLEX_TIME_DESCRIPTION}
                </li>
              </ul>
            );
          })
        ) : (
          <span>No data</span>
        )}
        <h5>{}</h5>
        <p>{}</p>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={() => {
            setADayLeaveModal(!aDayLeaveModal);
            setDateOnClick(null);
          }}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CalendarModal;
